import {observer} from "mobx-react";
import {Linq, Pager, ScrollTable} from "../../ui";
import {useNavigate, useSearchParams} from "react-router";
import {fmsPicklistOverviewStore, pageQueryStore} from "../../../store";
import {PageContentTitle} from "@kroschke/react-ui";
import {FmsPicklistFilterbar} from "./FmsPicklistFilterbar";
import {useEffect} from "react";

function dateFormat(date: string | undefined): string {
    if (!date) {
        return ''
    }
    return new Date(date).toLocaleString('de')
}

const FmsPicklistOverviewList = observer(function FmsPicklistOverviewList() {
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()

    useEffect(() => {
        pageQueryStore.restore('fms-picklist', searchParams, setSearchParams)
    }, [searchParams, setSearchParams])

    return <>
        <PageContentTitle
            actionItem={<FmsPicklistFilterbar/>}
        >
        </PageContentTitle>
        <ScrollTable>
            <thead>
            <tr>
                <th>ID</th>
                <th>Datum</th>
                <th style={{width: '12em'}}>Last Scan Status</th>
            </tr>
            </thead>
            <tbody>
            {fmsPicklistOverviewStore.items.map((val, index) => {
                const target = `/fms/picklist/${val.id}`
                return <tr
                    key={val.id}
                    style={{cursor: 'pointer'}}
                    onClick={() => {
                        navigate(target)
                    }}
                >
                    <td><Linq to={target}>{val.id}</Linq></td>
                    <td><Linq to={target}>{dateFormat(val.audit.createdDate)}</Linq></td>
                    <td><Linq to={target}>{val.itemsToScan > 0 ? 'Offen' : 'Abgeschlossen'}</Linq></td>
                </tr>
            })}
            </tbody>
        </ScrollTable>
        <Pager total={fmsPicklistOverviewStore.pages}/>
    </>
})

export {
    FmsPicklistOverviewList
}
